import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getUserData } from "../../../_seivices";

const Header = ({ toggleNav }) => {
    const [isDropdownOpenp, setIsDropdownOpenp] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => {
        setIsDropdownOpenp(true);
    };

    const handleMouseLeave = () => {
        setIsDropdownOpenp(false);
    };

    const onLogout = () => {
        localStorage.removeItem('loginId');
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('user');
        navigate('/');
    }

    const user = getUserData();

    return (
        <nav className="navbar navbar-expand navbar-dark sticky-top px-4 py-0 admin-navbar admin_fixed_header" style={{ background: "#ffffff" }}>
            <Link to="index.html" className="navbar-brand d-flex d-lg-none me-4">
                <h2 className="text-primary mb-0"><i className="fa fa-user-edit"></i></h2>
            </Link>
            {/* <span className="sidebar-toggler flex-shrink-0">
                ☰
            </span>  */}
            <div className="navbar-nav align-items-center ms-auto children-container">
                {/* <div className="nav-item dropdown">
                    <Link to="#" className="nav-link message-button" data-bs-toggle="dropdown">
                        <i className="fa fa-envelope me-lg-3"></i>
                    </Link>
                    <div className="dropdown-menu bg-transparent border-0 rounded-0 rounded-bottom m-0">
                        <Link to="#" className="dropdown-item">
                            <div className="d-flex align-items-center">
                                <img className="rounded-circle" src="https://img.freepik.com/premium-photo/indian-young-boy-with-indian-flag-his-hand_54391-2173.jpg" alt="" style={{ height: "40px", width: "40px" }} />
                                <div className="ms-2">
                                    <h6 className="fw-normal mb-0">Jhon send you a message</h6>
                                    <small>15 minutes ago</small>
                                </div>
                            </div>
                        </Link>
                        <hr className="dropdown-divider" />
                        <button type="button" className="dropdown-item" style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}>
                            <div className="d-flex align-items-center">
                                <img className="rounded-circle" src="https://img.freepik.com/premium-photo/indian-young-boy-with-indian-flag-his-hand_54391-2173.jpg" alt="" style={{ height: "40px", width: "40px" }} />
                                <div className="ms-2">
                                    <h6 className="fw-normal mb-0">Jhon send you a message</h6>
                                    <small>15 minutes ago</small>
                                </div>
                            </div>
                        </button>
                        <hr className="dropdown-divider" />
                        <button type="button" className="dropdown-item" style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}>
                            <div className="d-flex align-items-center">
                                <img className="rounded-circle" src="https://img.freepik.com/premium-photo/indian-young-boy-with-indian-flag-his-hand_54391-2173.jpg" alt="" style={{ height: "40px", width: "40px" }} />
                                <div className="ms-2">
                                    <h6 className="fw-normal mb-0">Jhon send you a message</h6>
                                    <small>15 minutes ago</small>
                                </div>
                            </div>
                        </button>
                        <hr className="dropdown-divider" />
                        <button type="button" className="dropdown-item text-center" style={{ background: "none", border: "none", width: "100%", textAlign: "center" }}>See all message</button>
                    </div>
                </div>

                <div className="nav-item dropdown">
                    <button
                        type="button"
                        className="nav-link btn btn-link p-0 notification-button"
                        data-bs-toggle="dropdown"
                        style={{ textDecoration: "none" }}
                        aria-label="Notifications"
                    >
                        <i className="fa fa-bell me-lg-2"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end bg-secondary border-0 rounded-0 rounded-bottom m-0">
                        <button type="button" className="dropdown-item" style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}>
                            <h6 className="fw-normal mb-0">Profile updated</h6>
                            <small>15 minutes ago</small>
                        </button>
                        <hr className="dropdown-divider" />
                        <button type="button" className="dropdown-item" style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}>
                            <h6 className="fw-normal mb-0">New user added</h6>
                            <small>15 minutes ago</small>
                        </button>
                        <hr className="dropdown-divider" />
                        <button type="button" className="dropdown-item" style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}>
                            <h6 className="fw-normal mb-0">Password changed</h6>
                            <small>15 minutes ago</small>
                        </button>
                        <hr className="dropdown-divider" />
                        <button type="button" className="dropdown-item text-center" style={{ background: "none", border: "none", width: "100%", textAlign: "center" }}>See all notifications</button>
                    </div>
                </div> */}

                <div className="nav-item dropdown user" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <Link to="#" className="nav-link dropdown-toggle d-flex gap-2 align-items-center" data-bs-toggle="dropdown" aria-expanded={isDropdownOpenp} >
                        <i className="fa fa-user" style={{ fontSize: "18px" }}></i>
                        <span className="d-none d-lg-inline-flex">{user?.name}</span>
                    </Link>
                    <div className={`dropdown-menu admin-profile-dropdown border-0 rounded-0 rounded-bottom m-0 ${isDropdownOpenp ? 'show' : ''}`} style={{ position: "absolute", right: 0, zIndex: '9999' }}>
                        {/* <Link to="#" className="dropdown-item profile-dropdown-item">My Profile</Link>
                        <Link to="#" className="dropdown-item profile-dropdown-item">Settings</Link> */}
                        <button onClick={() => onLogout()} className="dropdown-item profile-dropdown-item">Log Out</button>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Header;